import { useMemo } from 'react';

import { useEffectOnce, useUpdateEffect } from 'ui/hooks';
import { v4 as uuidv4 } from 'uuid';

import { useDrawer } from '../StackNavigatorProvider';

import type { DrawerProps } from './Drawer.d';

const DrawerBase = ({
  anchor = 'left',
  children,
  footer,
  header,
  headerIcon = 'Close',
  id,
  onClose = () => ({}),
  onOpen = () => ({}),
  open = false,
  size = 'default',
  title = '',
  withoutHeader,
  ...props
}: DrawerProps) => {
  const drawerID = useMemo(() => id || uuidv4(), [id]);
  const { popStateFromStack, pushStateToStack, updateDrawerStack } = useDrawer();

  const mountDrawer = () => {
    pushStateToStack({
      anchor,
      children,
      footer,
      header,
      headerIcon,
      id: drawerID,
      onClose,
      onOpen,
      open,
      size,
      title,
      withoutHeader,
      ...props,
    });
  };

  const unmountDrawer = () => {
    popStateFromStack(drawerID);
  };

  useUpdateEffect(() => {
    updateDrawerStack({
      children,
      header,
      headerIcon,
      id: drawerID,
      footer,
      open,
      title,
    });
  }, [children, header, footer, drawerID, open, title]);

  useEffectOnce(() => {
    mountDrawer();

    return unmountDrawer;
  });

  return null;
};

export default DrawerBase;
